import React from 'react';
import NiceModal, {useModal} from "@ebay/nice-modal-react";
import TrainingForm, {TrainingFormProps} from "../../../pages/consumers/training/components/Training/TrainingForm";
import {modalClose} from "../genericFunctions";
import SlideOver, {SlideOverProps} from "../../generic/SlideOver";


interface OwnProps extends SlideOverProps, TrainingFormProps {
}

type Props = OwnProps;

// @ts-ignore
const TrainingModal = NiceModal.create<Props>(({training, header, onClose}) => {
    const modal = useModal()

    const handleClose = (e) => {
        modalClose(e, modal, onClose)
    }

    return (
        <SlideOver onClose={handleClose} open={modal.visible} afterClose={modal.remove} title={header}>
            <TrainingForm training={training}/>
        </SlideOver>
    )
})

export default TrainingModal;
